<template>
    <div class="modal-overlay">
        <div class="modal-content-600">
            <h3>{{ props.nmDocModelo }}</h3>

            <div v-if="msgAlerta" class="alert-error">
                {{ msgAlerta }}
            </div>

            <div v-if="isLoading" class="margin-top10">
                Carregando...
            </div>

            <div v-else class="proc-permissoes-grid">
                <div class="proc-permissoes-header perfil">Perfil</div>
                <div class="proc-permissoes-header">Permissão</div>

                <template v-for="perfil in lsPerfil" :key="perfil.idperfil">
                    <div class="proc-permissoes-cell perfil">
                        {{ perfil.nmperfil }}
                    </div>

                    <div class="proc-permissoes-cell">
                        <input
                            type="checkbox"
                            v-model="perfil.ckpermitido"
                            true-value="S"
                            false-value="N"
                        />
                    </div>
                </template>
            </div>

            <div class="row-end margin-top10">
                <button type="button" class="btn-cancel" @click="$emit('close')">
                    Cancelar
                </button>
                <button type="button" class="btn-confirm" @click="salvarDados">
                    Salvar
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';

const isLoading = ref(false);
const msgAlerta = ref(null);
const lsPerfil = ref([]);

const emit = defineEmits(['close']);
const props = defineProps({
    idDocModelo: {
        type: Number,
        default: 0
    },
    nmDocModelo: {
        type: String,
        default: "Permissões de Acesso"
    },
});

function normalizarCheck(valor) {
    return valor === 'S' ? 'S' : 'N';
}


async function lerDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        const reqPerfil = await Api.genericPost('/listas/epdocmodelo/perfil', {
            idep: globalStore.idep,
            idreferencia: props.idDocModelo
        });

        lsPerfil.value = (reqPerfil || []).map(p => {
            const ck = normalizarCheck(p.ckpermitido);
            return {
                ...p,
                ckpermitido: ck,
                ckpermitido_original: ck
            };
        });

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

async function salvarDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        const alterados = lsPerfil.value.filter(perfil =>
            perfil.ckpermitido !== perfil.ckpermitido_original
        );

        for (const perfil of alterados){
            await Api.genericPost('/cad/exec_requisicao', {
                nmrequisicao: "epdocmodelo_perfil",
                intparam1: props.idDocModelo,
                intparam2: perfil.idperfil,
                ativo: perfil.ckpermitido,
                idlogin: globalStore.idlogin
            });
        }
        emit('close');
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

onMounted(lerDados);
</script>


<style scoped>
.proc-permissoes-grid {
    display: grid;
    grid-template-columns: 1fr 90px;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 12px;
}

.proc-permissoes-header {
    font-weight: 600;
    font-size: 13px;
    text-align: center;
    background: #f5f5f5;
    padding: 10px 8px;
    border-bottom: 1px solid #ddd;
}

.proc-permissoes-header.perfil {
    text-align: left;
}

.proc-permissoes-cell {
    padding: 9px 8px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: center;
}

.proc-permissoes-cell.perfil {
    justify-content: flex-start;
    font-weight: 500;
    text-align: left;
}

.proc-permissoes-cell input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.alert-error {
    margin-top: 10px;
    padding: 10px;
    border-radius: 6px;
    background: #ffe6e6;
    color: #8a0000;
}
</style>